import { render } from "./contentCategoryDetail.vue?vue&type=template&id=2b8b2a98&scoped=true&ts=true"
import script from "./contentCategoryDetail.vue?vue&type=script&lang=ts"
export * from "./contentCategoryDetail.vue?vue&type=script&lang=ts"

import "./contentCategoryDetail.vue?vue&type=style&index=0&id=2b8b2a98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8b2a98"]])

export default __exports__